export default "__VITE_ASSET__0de7aeb7__"